module.exports = __webpack_public_path__ + "img/Wp_2045.d44c0046.png";